// src/pages/Login.js
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Giriş başarısız. Lütfen bilgileri kontrol edin.');
    }
  };

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-logo">
          <span>🛡️</span>
        </div>
        <div className="login-title">Crypto Membership OS</div>
        <div className="login-subtitle">Master Admin Panel'e giriş yapın</div>
        
        <div className="input-group">
          <label>Kullanıcı Adı</label>
          <input
            className="input-field"
            type="text"
            placeholder="admin"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />
        </div>
        
        <div className="input-group">
          <label>Şifre</label>
          <input
            className="input-field"
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        
        <button className="login-button" type="submit">
          Giriş Yap
        </button>
        
        {error && <div className="error-message">{error}</div>}
        
        <div className="login-footer">
          Crypto Membership OS v1.0
        </div>
      </form>
    </div>
  );
};

export default Login;